import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['ManagementCompanyWorkforce']
});

const managementCompanyWorkforceApi = apiWithTags.injectEndpoints({
	tagTypes: ['ManagementCompanyWorkforce'],
	endpoints: (build) => ({
		getManagementCompanyInfo: build.query({
			query: (managementCompanyId) => ({
				url: `/management-companies/${managementCompanyId}`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyWorkforce']
		}),
		getWorkforceByManagementCompany: build.query({
			query: (managementCompanyId) => ({
				url: `flex/management-companies/${managementCompanyId}/workforce`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyWorkforce']
		}),
		getProfessional: build.query({
			query: ({ managementCompanyId, caregiverId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyWorkforce']
		}),
		getUpcomingShiftsByProfessional: build.query({
			query: ({ managementCompanyId, caregiverId, queryParams = '' }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/workforce/upcoming-shifts?${queryParams}`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyWorkforce']
		}),
		updateWorkforceStatus: build.mutation({
			query: ({ managementCompanyId, caregiverId, body }) => ({
				url: `flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/workforce/status`,
				method: 'PUT',
				body,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			invalidatesTags: ['ManagementCompanyWorkforce']
		}),
		getNoteCategories: build.query({
			query: ({ managementCompanyId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/note-categories`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyWorkforce']
		}),
		getNotes: build.query({
			query: ({ managementCompanyId, caregiverId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/notes`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['ManagementCompanyWorkforce']
		}),
		addNote: build.mutation({
			query: ({ managementCompanyId, caregiverId, body }) => ({
				url: `flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/notes`,
				method: 'POST',
				body,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			invalidatesTags: ['ManagementCompanyWorkforce']
		}),
		updateEmployeeIDs: build.mutation({
			query: ({ managementCompanyId, caregiverId, body }) => ({
				url: `flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/employee-ids`,
				method: 'PUT',
				body,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			invalidatesTags: (result, errors) => {
				if (result && !errors) {
					return ['ManagementCompanyWorkforce'];
				}
				return [];
			}
		})
	})
});

export const {
	useGetManagementCompanyInfoQuery,
	useGetWorkforceByManagementCompanyQuery,
	useGetProfessionalQuery,
	useGetUpcomingShiftsByProfessionalQuery,
	useLazyGetUpcomingShiftsByProfessionalQuery,
	useUpdateWorkforceStatusMutation,
	useGetNotesQuery,
	useAddNoteMutation,
	useGetNoteCategoriesQuery,
	useUpdateEmployeeIDsMutation
} = managementCompanyWorkforceApi;
